import React, { useEffect } from 'react';
import { Support } from '../../hooks/Support';

export type ChromeCastProps = {
  authorization: string;
  enabled: boolean;
  code: string;
  video: string;
  videoName: string;
  videoPoster: string;
  supported: Support;
};

const ChromeCast = ({ authorization, enabled, code, video, videoName, videoPoster, supported }: ChromeCastProps) => {
  const [isChromeCast, setIsChromecast] = React.useState<boolean>(false);

  const chromecastVideo = () => {
    if (!supported.chromecast) {
      return;
    }

    // const source = document.createElement('source');
    // source.src = video;
    // source.type = 'application/x-mpegURL';

    const rootElement = document.querySelector(`[data-code="${code}"]`) as HTMLDivElement;
    const videoElement = rootElement.querySelector('video') as HTMLVideoElement;
    // console.log('video', videoElement);
    // videoElement.appendChild(source);
    videoElement.disableRemotePlayback = false;

    const chrome = (window as any).chrome;
    const cast = (chrome as any).cast;

    let session = null;

    function sessionListener(event: any) {
      session = event;
      console.log('New session');

      if (session.media.length != 0) {
              console.log('Found ' + session.media.length + ' sessions.');
      }
    }

    function receiverListener(event: any) {
      if(event === 'available' ) {
        console.log("Chromecast was found on the network.", event);
      } else {
        console.log("There are no Chromecasts available.", event);
      }
    }

    // const context = cast.framework.CastReceiverContext.getInstance();

    // const playerManager = context.getPlayerManager();

    // const playbackConfig = new cast.framework.PlaybackConfig();
    // playbackConfig.manifestRequestHandler = (requestInfo: any) => {
    //     requestInfo.headers = {
    //       Authorization: authorization
    //     };
    // };

    // playerManager.setMessageInterceptor(cast.framework.messages.MessageType.LOAD, (requestData: any) => {
    //   playerManager.setPlaybackConfig(playbackConfig);
    //   return requestData;
    //   }
    // );

    const sessionRequest = new cast.SessionRequest(chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID);

    const apiConfig = new cast.ApiConfig(sessionRequest, sessionListener, receiverListener);

    const link = `${video}&authorization=${authorization}`;

    (window as any).cast.framework.setLoggerLevel((window as any).cast.framework.LoggerLevel.DEBUG);

    cast.initialize(apiConfig, () => {
      cast.requestSession((session: any) => {
        const mediaInfo = new cast.media.MediaInfo(link, 'application/x-mpegURL');

        mediaInfo.streamType = cast.media.StreamType.BUFFERED;
        mediaInfo.contentType = 'application/x-mpegURL';
        mediaInfo.metadata = new cast.media.GenericMediaMetadata();
        mediaInfo.metadata.title = videoName;
        mediaInfo.metadata.images = [
          new cast.Image(videoPoster || ''),
        ];

        const request = new cast.media.LoadRequest(mediaInfo);
        request.autoplay = true;

        session.loadMedia(request);

        setIsChromecast(true);
      });
    }, (error: any) => {
      setIsChromecast(false);
    });
  }

  if (!enabled || !supported.chromecast) {
    return null;
  }

  return (
    <div className={`${isChromeCast ? 'smartplayer__chromecast--active' : 'smartplayer__chromecast--inactive'}`} onClick={() => chromecastVideo()}>
      <button className="smartplayer__bar-button" type="button">
        <div className="icon icon--chromecast-active">
          <svg xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 512 512" fill="currentColor">
            <path d="M447.8 64H64c-23.6 0-42.7 19.1-42.7 42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6 0 42.7-19.1 42.7-42.7V106.7C490.7 83.1 471.4 64 447.8 64zM21.3 383.6L21.3 383.6l0 63.9h63.9C85.2 412.2 56.6 383.6 21.3 383.6L21.3 383.6zM21.3 298.6V341c58.9 0 106.6 48.1 106.6 107h42.7C170.7 365.6 103.7 298.7 21.3 298.6zM213.4 448h42.7c-.5-129.5-105.3-234.3-234.8-234.6l0 42.4C127.3 255.6 213.3 342 213.4 448z"/>
          </svg>
        </div>
        <div className="icon icon--chromecast-inactive">
          <svg xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 512 512" fill="currentColor">
            <path d="M447.8 64H64c-23.6 0-42.7 19.1-42.7 42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6 0 42.7-19.1 42.7-42.7V106.7C490.7 83.1 471.4 64 447.8 64zM21.3 383.6L21.3 383.6l0 63.9h63.9C85.2 412.2 56.6 383.6 21.3 383.6L21.3 383.6zM21.3 298.6V341c58.9 0 106.6 48.1 106.6 107h42.7C170.7 365.6 103.7 298.7 21.3 298.6zM213.4 448h42.7c-.5-129.5-105.3-234.3-234.8-234.6l0 42.4C127.3 255.6 213.3 342 213.4 448z"/>
          </svg>
        </div>
      </button>
    </div>
  );
};

export default ChromeCast;
